import { useDispatch, useSelector } from "react-redux"

import { ContentContainer } from "./styled"
import { MenuItem } from "../../components/MenuItem"
import { setNextStep } from "../../store/slices/routingSlice/routingSlice"
import { useGetLinkedBanksList } from "../../api/hooks/useGetLinkedBanksList"
import BankItem from "../../components/BankItem"
import { RootState } from "../../store/store"
import { useGetDefaultPaymentToolBank } from "../../api/hooks/useGetDefaultPaymentToolBank"
import { setSelectedBank } from "../../store/slices/m2mSlice"
import { IBankMeta } from "../../api/interface"
import { STEPS_NAME } from "../../store/slices/routingSlice/flowsSteps"

const PaymentToolsM2M = () => {
  const selectedBank = useSelector(
    (state: RootState) => state.refillM2M.selectedBank,
  )
  const dispatch = useDispatch()
  const { data } = useGetLinkedBanksList()
  const { data: defaultPaymentToolBank } = useGetDefaultPaymentToolBank()
  const getBankProps = (id: string) => {
    if (id === selectedBank?.bankId) {
      return {
        description: "Через СБП",
        icon: "checkMark",
      }
    }
    if (id === defaultPaymentToolBank?.bankId && !selectedBank) {
      return {
        description: "Через СБП",
        icon: "checkMark",
      }
    }
    return undefined
  }

  const handleBankSelectionClick = () => {
    dispatch(setNextStep(STEPS_NAME.m2mPull.linkingBankSelection))
  }

  const handleBankClick = (bank: IBankMeta) => {
    dispatch(setSelectedBank(bank))
    dispatch(setNextStep(STEPS_NAME.m2mPull.refill))
  }

  return (
    <ContentContainer>
      {data &&
        data.map((bankItem) => (
          <BankItem
            bank={bankItem}
            description={getBankProps(bankItem.bankId)?.description}
            onClick={() => handleBankClick(bankItem)}
            endIcon={getBankProps(bankItem.bankId)?.icon}
          />
        ))}

      <MenuItem
        icon="sbpIcon"
        title="Выбрать другой банк"
        subtitle="Через СБП"
        onClick={handleBankSelectionClick}
      />
    </ContentContainer>
  )
}

export default PaymentToolsM2M
